import React, { useState } from "react";
import { ColumnProps } from "antd/lib/table/interface";
import Layout from "../components/Layout";
import StuTable from "../components/StuTable";
import useRequest from "../../../../utils/useRequest";
import {
    getExamStudentFaceList,
    StudentFaceListItem
} from "../../../../service/exam";
import InvigilationProvider from "../context";
import AsidePhotoList from "./components/AsidePhotoList";

export default function CamCaptureRecord() {
    const [examId, setExamId] = useState("");
    const [studentName, setStudentName] = useState("");

    const [data, { loading }, refresh] = useRequest(
        () => getExamStudentFaceList({ studentName, examId }),
        {},
        [examId, studentName]
    );

    const columns: ColumnProps<StudentFaceListItem>[] = [
        // {
        //     title: "打开试卷时间",
        //     dataIndex: "firstStartTime",
        //     align: "center",
        //     width: 100,
        //     render: time => time && moment(time).format("MM-DD HH:mm")
        // },
        // {
        //     title: "提交试卷时间",
        //     dataIndex: "submitTime",
        //     align: "center",
        //     width: 100,
        //     render: time => time && moment(time).format("MM-DD HH:mm")
        // }
    ];

    return (
        <InvigilationProvider
            examId={examId}
            setExamId={setExamId}
            examList={data?.conditionQueryList || []}
            dataSource={data?.dataList || []}>
            <Layout
                title="考生抓拍记录"
                refresh={refresh}
                table={
                    <StuTable
                        onErrChange={refresh}
                        dataSource={data?.dataList || []}
                        buttonShow={[true, false, true, true]}
                        loading={loading}
                    />
                }
                aside={<AsidePhotoList />}
                onSearch={setStudentName}
            />
        </InvigilationProvider>
    );
}
